import request from "@/api/index";
/* 教育局端统计分析-接口 */
/* 学生托管统计-接口 */
//托管学生报名分布环图
export function handleStudentSignUp(params) {
    return request({
        url:'/dataservice/api/1/1345',
        method: "get",
        params,
    });
}
//学生出勤变化趋势折线图
export function handleStudentAttendance(params) {
    return request({
        url:'/dataservice/api/1/1346',
        method: "get",
        params,
    });
}
//统计明细表
export function handleDetailedList(params) {
    return request({
        url:'/dataservice/api/1/1348',
        method: "get",
        params,
    });
}
/* 学校开课统计-接口 */

//课程提供方分布环图
export function handleCurriculumProvide(params) {
    return request({
        url:'/dataservice/api/1/1351',
        method: "get",
        params,
    });
}
//课程类型分布环图
export function handleCurriculumType(params) {
    return request({
        url:'/dataservice/api/1/1329',
        method: "get",
        params,
    });
}
//课程报名率提供方对比柱图
export function handleEnrollmentRatet(params) {
    return request({
        url:'/dataservice/api/1/1352',
        method: "get",
        params,
    });
}
//课程报名率类型对比柱图
export function handleSignUpType(params) {
    return request({
        url:'/dataservice/api/1/1353',
        method: "get",
        params,
    });
}
//开课数统计明细表
export function handleOpenClassList(params) {
    return request({
        url:'/dataservice/api/1/1355',
        method: "get",
        params,
    });
}
//报名率统计明细表
export function handleSignUpList(params) {
    return request({
        url:'/dataservice/api/1/1354',
        method: "get",
        params,
    });
}
/* 机构课程统计-接口 */

//机构提供课程数排行
export function handleCurriculumTotal(params) {
    return request({
        url:'/dataservice/api/1/1357',
        method: "get",
        params,
    });
}
//课程开课次数排行
export function handleCurriculumOpen(params) {
    return request({
        url:'/dataservice/api/1/1358',
        method: "get",
        params,
    });
}
//课程统计明细表
export function handleCurriculumList(params) {
    return request({
        url:'/dataservice/api/1/1359',
        method: "get",
        params,
    });
}
/* 课程评价统计-接口 */

//课程评价分布情况
export function handleCurriculumEvaluation(params) {
    return request({
        url:'/dataservice/api/1/1360',
        method: "get",
        params,
    });
}
//学校课程平均评价排行
export function handleCurriculumEvaluationSchool(params) {
    return request({
        url:'/dataservice/api/1/1361',
        method: "get",
        params,
    });
}
//机构课程平均评价排行
export function handleCurriculumListMechanism(params) {
    return request({
        url:'/dataservice/api/1/1362',
        method: "get",
        params,
    });
}